// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    getClaimTypes,
    getSubClaimTypes
} from '../../../shared/repositories';
import actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';
import {getClaimRoutes} from '../../../shared/components/create-claim-modal/get-claim-routes-service';
import {getCombinedClaimTypes} from '../../../shared/services/build-claim-types';
import {routerActions} from 'react-router-redux';

export const getClaimTypeList = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const allPromises = Promise.all.bind(Promise);

        try {

            const [claimTypes, subClaimTypes] = await allPromises([
                getClaimTypes(),
                getSubClaimTypes()
            ]);

            dispatch({
                claimTypes: getCombinedClaimTypes(claimTypes, subClaimTypes),
                type: actions.SET_SEARCH_RESULT_CLAIM_TYPES
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const toggleCreateClaimModal = (isOpen, pin = '') =>

    dispatch => {

        addRemoveModalClass(isOpen);

        dispatch({
            isOpen,
            pin,
            type: actions.TOGGLE_SEARCH_RESULT_CREATE_CLAIM_MODAL
        });

    };

export const onCreateClaim = (key, pin) =>

    dispatch => {

        dispatch(routerActions.push(getClaimRoutes(key, pin)));

    };



// WEBPACK FOOTER //
// ./src/product/search/action-creators/create-claim-modal.js